import { STATES } from '../../../../../constants';
import { actions } from '../../../../../state';
import { initializePromotionsComponent } from './initialize';
import { isFeatureEnabled } from '@updater-core/lib/optimizely';

export function ForwardMailPromotionsConfig($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.STEP_FORWARD_MAIL_PROMOTIONS, {
    url: '/claim-deals',
    views: {
      '@': {
        template: async () => {
          const isInRedesignTest = await isFeatureEnabled('fym_reskin');
          return `
            <div class="${
              isInRedesignTest
                ? 'fym-uds-promotions-interstitial'
                : 'fym-promotions-interstitial'
            }">
              <h2>While we verify your identification...</h2>
              <upd-fym-promotions interactor="interactor" self-contained="true" after-claim="goToNext">
              </upd-fym-promotions>
              <a ui-sref="^.list">I'm not interested</a>
            </div>
          `;
        },
        controller: (updStore, $scope) => {
          $scope.interactor = initializePromotionsComponent(
            updStore,
            'interstitial',
            $scope
          );
          $scope.goToNext = function () {
            updStore.dispatch(
              actions.router.stateGo(STATES.STEP_FORWARD_MAIL_LIST)
            );
          };
        },
      },
    },
    title: 'Forward Your Mail',
    scrollTop: true,
    reloadOnSearch: false,
    // Ignore breadcrumb - parent title is used instead
    ignore: true,
    disableBreadcrumb: true,
    analytics: {
      page: 'Forward Mail Promotions',
    },
  });
}
